import { __extends } from "tslib";
import { verticalsTypes } from './consts';
var fetchCreator = function (type, instance, locale, limit) {
    var url = "/_serverless/vertical-oembed/query-" + verticalsTypes[type] + "?language=" + locale;
    if (limit) {
        url += "&limit=" + limit;
    }
    return typeof fetch === 'function'
        ? fetch(url, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                Authorization: instance,
            },
        }).then(function (res) {
            if (res.ok)
                return res.json();
            else
                throw res.statusText;
        })
        : Promise.resolve(false);
};
var getItems = function (type, instance, locale, limit) {
    return fetchCreator(type, instance, locale, limit).then(function (response) {
        if (response.status) {
            return response.status === 'success' ? response.data : [];
        }
        //support legacy api
        return response;
    });
};
var AbstractVerticalSearchModule = /** @class */ (function () {
    function AbstractVerticalSearchModule() {
    }
    return AbstractVerticalSearchModule;
}());
var VerticalSearchModule = /** @class */ (function (_super) {
    __extends(VerticalSearchModule, _super);
    function VerticalSearchModule(verticalType, instance, locale, limit) {
        var _this = _super.call(this) || this;
        _this.verticalType = verticalType;
        _this.instance = instance;
        _this.locale = locale;
        _this.limit = limit;
        return _this;
    }
    VerticalSearchModule.prototype.isInstalled = function () {
        if (!this.isVerticalInstalled) {
            this.isVerticalInstalled = fetchCreator(this.verticalType, this.instance, this.locale, 0).then(function (res) { return !res.errMsg; });
        }
        return this.isVerticalInstalled;
    };
    VerticalSearchModule.prototype.search = function (searchInput) {
        if (!this.items) {
            this.items = getItems(this.verticalType, this.instance, this.locale, this.limit);
        }
        return this.items.then(function (res) {
            return res.filter(function (item) { return item.name.toLowerCase().includes(searchInput.toLowerCase()); });
        });
    };
    return VerticalSearchModule;
}(AbstractVerticalSearchModule));
export default VerticalSearchModule;
//# sourceMappingURL=VerticalSearchModule.js.map